import script from "./LoadingCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
